module.exports = __webpack_public_path__ + "img/spectrum-rvs.79acb5bb.png";